import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';

import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { ToastrService } from 'ngx-toastr';
import { DesktopSecurityFeatureDto, Otp, ParentalControlDto, SecurityFeatureDto, SystemParentalDto, SystemParentalPayload, OtherDeviceSettings } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { CommonEnums } from 'src/app/utils/enum-utils';
declare let $: any
interface TimeSlot {
  from: string;
  to: string;
}

@Component({
  selector: 'app-desktop-settings',
  templateUrl: './desktop-settings.component.html',
  styleUrls: ['./desktop-settings.component.scss']
})
export class DesktopSettingsComponent implements OnInit {
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @ViewChild("pinInput") pinInput: any;
  selectedIndex1: number = -1;
  selectedIndexing: any;
  items: any;
  selectedIn: any;
  searchText: any
  mobileNumber: string = "";
  deviceId: string | null = null;
  DesktopSecurityFeatureDto: DesktopSecurityFeatureDto = new DesktopSecurityFeatureDto();
  mobileDevice: any[] = [];
  otherDevices: any[] = [];
  otherDevicesParental: any[] = [];
  selectedSystems: any[] = [];
  systemName: String = '';
  isLoading: boolean = false;
  desktopSettings: any = [];
  selectedI: number = 0;
  nextSelecctedI: number = 0;
  nextData: any;
  screenWidth: number = 0;
  isMobileScreen: boolean = false;
  restrictWebCategoryList: any = [];
  restAppCatergoryList: any = [];
  allWebChecked: boolean = false;
  webCatList = new Set();
  appCatList = new Set();
  individualWebChecked: boolean = false;
  enJsonData: any[];
  tabsData: any;
  isincludeSubDomain: boolean = false;
  isExcludedSubDomain: boolean = false;
  internetTab: boolean = true;
  appTab: boolean = false;
  schedularTab: boolean = false;
  excludeExist: null;
  parentalJsonString: any;
  selectedValue: string;
  parentalDtoList: SystemParentalDto[] = [];
  privacyStatusBg: String = "#DEE9FE";
  privacyStatusClr: String = "#3F3F3F";
  parentalLastUpdated: Date = new Date();
  lastConncetdDate: Date = new Date();
  hourSelctVal: number[] = Array.from({ length: 24 }, (_, i) => i + 1);
  disableSlotTypes: boolean = true;
  parentalSettingsPayload: SystemParentalPayload = new SystemParentalPayload();
  otherDeviceSettings: OtherDeviceSettings = new OtherDeviceSettings();
  disableApply: boolean = false;
  isParentalOn: boolean = true;
  toggleOff_bg_badge_clr: String = '#F1F1F1';
  toggleOn_bg_badge_clr: String = '#DBFFE4';
  toggleOff_txt_color: String = '#919191';
  toggleOn_txt_color: String = '#009A1F';
  featureToggleMap: Map<string, boolean>;
  isUnsavedPS: boolean = false;
  isUnsavedFire: boolean = false;
  isUnsavedRans: boolean = false;
  isUnsavedVirus: boolean = false;
  changesPerUser: { [user: string]: boolean } = {};
  userTimezone: string;

  SettingsType: string[] = [
    "SYSTEM_PARENTAL_SETTINGS", "PROTECTION_SETTINGS", "PROTECTION_SETTINGS", "PROTECTION_SETTINGS"
  ];

  crwSupportedProductTypes: string[] = [
    'QH_LITE',
    'QH_IS_ESSENTIAL',
    'QH_PLUS',
    'QH_TS',
  ];

  saveSuccessMessage: string = '';
  securityFeatureForm: FormGroup = new FormGroup({
    deviceId: new FormControl(''),
    desktopSettingType: new FormControl(''),
    ransomwareProtection: new FormControl(''),
    virusProtection: new FormControl(''),
    firewallProtection: new FormControl(''),
    idsIpsProtection: new FormControl('')
  });



  restorePublishForm: FormGroup = new FormGroup({
    restore: new FormControl(''),
    publish: new FormControl(''),
    mobileDeviceName: new FormControl('')
  })

  deviceDetailForm: FormGroup = new FormGroup({
    userName: new FormControl(''),
    countryCode: new FormControl(''),
  });

  deviceForm: FormGroup = new FormGroup({
    deviceIds: new FormArray([]),
  })

  systemId: any;
  comingManageDevice: boolean;
  devicesList: any;
  jsonString: any;
  allAppChecked: boolean = false;
  individualAppChecked: boolean = false;
  blockedAppList: any;
  excludedAppList: any;
  userList: any = [];
  parentalControlDto: SystemParentalDto = new SystemParentalDto();
  currentUser: any;
  deskCompatibleVer: any;
  recordExistBlock: any;
  userName: any;
  userRole: any;
  selecetedTimeslot: boolean = false;
  scheduledSlots: any;
  timeForm: any;
  days: { id: string, name: string }[] = [
    { id: 'SUNDAY', name: 'PARENTALREPORTS.WEEKDAYS.SUNDAY' },
    { id: 'MONDAY', name: 'PARENTALREPORTS.WEEKDAYS.MONDAY' },
    { id: 'TUESDAY', name: 'PARENTALREPORTS.WEEKDAYS.TUESDAY' },
    { id: 'WEDNESDAY', name: 'PARENTALREPORTS.WEEKDAYS.WEDNESDAY' },
    { id: 'THURSDAY', name: 'PARENTALREPORTS.WEEKDAYS.THURSDAY' },
    { id: 'FRIDAY', name: 'PARENTALREPORTS.WEEKDAYS.FRIDAY' },
    { id: 'SATURDAY', name: 'PARENTALREPORTS.WEEKDAYS.SATURDAY' },
  ];
  times: string[] = [
    '12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM', '5:00 AM',
    '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM',
    '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM',
    '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM'
  ];
  dayMap: { [key: string]: number } = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7
  };

  selectedDays: string[] = [];
  slots: Record<string, TimeSlot[]> = {};
  dropdownOpen = false;
  allSelected = false;
  enableSchedular = false;
  timeSlotForm!: FormGroup;
  dayTimeslotsList: Set<{ day: number, hours: number }> = new Set();
  ransomwareProtection: any;
  virusProtection: any;
  showProtectionSettingModal: boolean;
  title: string;
  selectedTime = 1;
  description: string;
  timeOptions = [
    { value: 1, labelKey: 'SETTINGS.PROTECTION_MODAL.timeOptions.1' },
    { value: 2, labelKey: 'SETTINGS.PROTECTION_MODAL.timeOptions.2' },
    { value: 3, labelKey: 'SETTINGS.PROTECTION_MODAL.timeOptions.3' },
    { value: 4, labelKey: 'SETTINGS.PROTECTION_MODAL.timeOptions.4' },
  ];
  firewallIdsIps: any;
  firewallProtection: any;
  idsIpsProtection: any;
  ransomewareProtectionOnValue: number | undefined;
  virusProtectionOnValue: number | undefined;
  protectionSettingLastUpdated: string | number | Date;
  savedProtectionSettings: any;
  isPremium: boolean = false;
  productKey: string = '';
  renewalUrl: string = '';
  productType: string = '';
  expiryDays: any;
  expiryDate: any;
  enDataJson: any[];
  savedParentalCntrlSettings: any;
  systemInfo: any;
  selectedUserId: any;
  interntionalUrl: string | null;
  selectedLanguage: string = '';

  constructor(private _activatedRout: ActivatedRoute, private _service: ApiService, private router: Router, private _formBuilder: FormBuilder, private _toaster: ToastrService,
    private encrypt: EncryptionService, private translateService: TranslateService, private cdr: ChangeDetectorRef) {
    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this.translateService.use(this.selectedLanguage);
    }
    translateService.get(["SETTINGS"]).subscribe((values) => {
      this.enJsonData = Object.keys(values).map(key => values[key]);
      this.desktopSettings = this.enJsonData[0].DESKTOPSETTINGS;
      this.saveSuccessMessage = this.enJsonData[0].SUCCESSSTRING;
    }
    );
  }
  currentUserData: any
  ngOnInit(): void {
    this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    window.clearTimeout(500)
    this.selectedI = 0;
    this.currentUserData = JSON.parse(localStorage.getItem('currentUser')!);
    this.interntionalUrl = localStorage.getItem('desktopPurchaseNowInternational');
    this._activatedRout.queryParamMap.subscribe(params => {
      this.deviceId = params.get('systemId');
    });
    this.selectedUserId = this._activatedRout.snapshot.params['id'];
    this.getParentalSettings();
    this.getFirewallIdsIpsSetting();
    setTimeout(() => {
      this.pinInput?.nativeElement.focus();
    }, 300);
    this.timeSlotForm = this._formBuilder.group({
      fromTime: ['', Validators.required],
      toTime: ['', Validators.required]
    });
    this.securityFeatureValidation();
    this.getSystemInUser();
    if (this.currentUserData.mobileNo) {
      this.deviceDetailForm.controls['userName'].setValue(this.currentUserData.mobileNo)
    }
    this.screenWidth = window.screen.width;
    if (this.screenWidth <= 992) {
      this.isMobileScreen = true;
    } else {
      this.isMobileScreen = false;
    }
    this.featureToggleMap = new Map<string, boolean>([
      ["SMART_PARENTAL_SETTINGS", true], ["IDS_IPS_SETTINGS", true], ["RANSOMWARE_PROTECTION", true], ["VIRUS_PROTECTION", true]
    ]);
    this.deskCompatibleVer = localStorage.getItem('DesktopCompatibleVersion');
  }
  //  ngOnDestroy() {

  //         }

  onMobileDeviceSelect(evt: any) {
    this.selectedI = 0;
    this.toggleOn = false;
    this.deviceId = evt;
    this.getParentalSettings();
  }

  getSystemInUser() {
    this.isLoading = true;
    let apiUrl: any;
    try {
      apiUrl = `${this._service.API_URL.getSystemInUser}?timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
      this._service.getService(apiUrl).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.mobileDevice = response.data;
          this.otherDevices = response.data.filter((data: any) => data.id != this.deviceId && data?.isPremium && !(parseFloat(data?.productVersion) < parseFloat(this.deskCompatibleVer)));
          this.otherDevicesParental = response.data.filter((data: any) => data.id != this.deviceId && data?.isPremium && !(parseFloat(data?.productVersion) < parseFloat(this.deskCompatibleVer)) && !(data?.productType === 'QH_IS_ESSENTIAL' || data?.productType === 'QH_LITE'));
          const deviceInfo = response.data.filter((data: any) => data.id === this.deviceId);
          this.systemInfo = deviceInfo[0];
          this.isPremium = deviceInfo[0].isPremium;
          this.productKey = deviceInfo[0].productKey;
          this.productType = deviceInfo[0].productType;
          this.systemName = deviceInfo[0].deviceName;
          this.userName = deviceInfo[0].name;
          this.expiryDays = Number(deviceInfo[0].expirydays);
          this.expiryDate = deviceInfo[0].expiryDate;
          this.restorePublishForm.controls['mobileDeviceName'].setValue(this.deviceId);
          this.userRole = deviceInfo[0].roleTypeStr;
        } else {
          this.isLoading = false;
        }

      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  checkBeforeSwitchTab(i: any, data: any) {
    this.nextSelecctedI = i;
    this.nextData = data;
    // if (this.selectedI === 0) {
    if (i === this.selectedI) {
      return;
    }
    if (this.selectedI === 0) {
      if (this.isUnsavedPS) {
        this.checkForUnsavedSettings(this.selectedI);
      } else {
        this.selectedIndex(i, data);
      }
    } else if (this.selectedI === 1) {
      if (this.isUnsavedFire) {
        this.checkForUnsavedSettings(this.selectedI);
      } else {
        this.selectedIndex(i, data);
      }
    } else if (this.selectedI === 2) {
      if (this.isUnsavedRans) {
        this.checkForUnsavedSettings(this.selectedI);
      } else {
        this.selectedIndex(i, data);
      }
    } else if (this.selectedI === 3) {
      if (this.isUnsavedVirus) {
        this.checkForUnsavedSettings(this.selectedI);
      } else {
        this.selectedIndex(i, data);
      }
    }
    else {
      this.selectedIndex(i, data);
    }

  }

  saveBtnDisable: boolean = true;
  selectedIndex(i: any, data: any) {
    this.selectedIndex1 = -1
    this.selectedIndexing = -1;
    this.selectedI = i;
    this.saveBtnDisable = true;
    this.securityFeatureForm.markAsPristine();

    this.getSettings(i);
  }


  checkForUnsavedSettings(index: any) {
    this.openUnsavedPopup();
  }

  getFeatureStatus(key: string) {
    return this.featureToggleMap.get(key) ?? false;
  }



  securityFeatureValidation() {
    this.securityFeatureForm = this._formBuilder.group(
      {
        deviceId: [this.deviceId],
        ransomwareProtection: [false],
        virusProtection: [false],
        firewallProtection: [false],
        idsIpsProtection: [false]
      },
    );
  }

  saveDesktopSetting(value: any) {
    this.securityFeatureForm.value.deviceId = this.deviceId
    try {
      this.isLoading = true;
      this.isUnsavedFire = false;
      this.isUnsavedRans = false;
      this.isUnsavedVirus = false;
      this.DesktopSecurityFeatureDto.idsIpsProtection = this.idsIpsProtection;
      this.DesktopSecurityFeatureDto.firewallProtection = this.firewallProtection;
      this.DesktopSecurityFeatureDto.ransomwareProtection = this.ransomwareProtection
      this.DesktopSecurityFeatureDto.ransomewareProtectionOnValue = this.ransomewareProtectionOnValue;
      this.DesktopSecurityFeatureDto.virusProtectionOnValue = this.virusProtectionOnValue;
      this.DesktopSecurityFeatureDto.virusProtection = this.virusProtection;
      this.DesktopSecurityFeatureDto.deviceId = this.deviceId;
      this.DesktopSecurityFeatureDto.desktopSettingType = value;
      this._service.putService(this._service.API_URL.saveDesktopSettings, this.DesktopSecurityFeatureDto).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.saveBtnDisable = true;
          this.isLoading = false;
          this.securityFeatureForm.markAsPristine();
          this._toaster.success('', response.status.message);

        }
        else {
          this._toaster.error('', response.status.message);
          this.isLoading = false;
        }

      }
      )
    }
    catch (error) {
      this.isLoading = false;
    }
  }


  getDesktopFeatures(deviceId: any) {
    try {
      this.isLoading = true;
      this._service.getService(this._service.API_URL.getDesktopSetting + deviceId).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.securityFeatureForm.controls['deviceId'].setValue(this.deviceId)
          this.securityFeatureForm.controls['ransomwareProtection'].setValue(response.data.ransomwareProtection);
          this.securityFeatureForm.controls['virusProtection'].setValue(response.data.virusProtection);
          this.securityFeatureForm.controls['firewallProtection'].setValue(response.data.firewallProtection);
          this.securityFeatureForm.controls['idsIpsProtection'].setValue(response.data.idsIpsProtection);
          this.securityFeatureForm.markAsPristine();
        }
        else {
          this.isLoading = false;

        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  premiumMsg: string | null = null;
  public get CommonEnum(): typeof CommonEnums {
    return CommonEnums;
  }


  publish(selectedI: number) {
    try {
      $('#publishPopup').modal('hide');
      this.isLoading = true;


      let data = {
        "deviceId": this.deviceId,
        "requestType": this.SettingsType[selectedI]
      }
      if (data.requestType === 'SYSTEM_PARENTAL_SETTINGS') {
        this.saveDeskParentalSettings()
      } else if (data.requestType === 'PROTECTION_SETTINGS') {
        this.saveDesktopSetting('PROTECTION_SETTING');
      }


      this.DesktopSecurityFeatureDto.deviceId = data.deviceId;
      this.DesktopSecurityFeatureDto.systemRequestType = data.requestType;

      this._service.postService(this._service.API_URL.desktopPublish, this.DesktopSecurityFeatureDto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toaster.success('', response.status.message);
          if ((selectedI === 0 && this.otherDevicesParental.length > 0) && data.requestType != "SYSTEM_PARENTAL_SETTINGS") {
            this.openupdatePopup()
          } else if ((selectedI != 0 && this.otherDevices.length > 0) && data.requestType != "SYSTEM_PARENTAL_SETTINGS") {
            this.openupdatePopup()
          }
        } else {
          this.isLoading = false;
          this._toaster.error('', response.status.message)
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  getSettings(selectedI: number) {
    try {
      let apimap = '';
      switch (selectedI) {
        case 0:
          this.getParentalSettings();
          break;
        case 1:
          this.getFirewallIdsIpsSetting();
          break;
        case 2:
          this.getRansomewareProtectionSetting();
          break;
        case 3:
          this.getVirusProtectionSetting();
          break;
        default:
          console.log("No mapping found");
      }
    } catch (error) {
      this.isLoading = false;
    }
  }
  getVirusProtectionSetting() {
    this.systemId = this.deviceId;
    this._service.getService(this._service.API_URL.getDeskProtectionSettingsAPI + this.systemId).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.virusProtection = response.data.virusProtection;
        this.savedProtectionSettings = response.data;
        this.protectionSettingLastUpdated = response.data.lastUpdatedDate;
        this.setControlStates(response.data);
      } else {
        this.isLoading = false;
        if (response.status.msgCode === "DESKTOP_SETTINGS_NOT_FOUND") {
          this.virusProtection = true;
          this.savedProtectionSettings.virusProtection = true;
        }
      }
    })
  }
  getRansomewareProtectionSetting() {
    this.systemId = this.deviceId;
    this._service.getService(this._service.API_URL.getDeskProtectionSettingsAPI + this.systemId).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.ransomwareProtection = response.data.ransomwareProtection;
        this.savedProtectionSettings = response.data;
        this.protectionSettingLastUpdated = response.data.lastUpdatedDate;
        this.setControlStates(response.data);
      } else {
        this.isLoading = false;
        if (response.status.msgCode === "DESKTOP_SETTINGS_NOT_FOUND") {
          this.ransomwareProtection = true;
          this.savedProtectionSettings.ransomwareProtection = true;
        }
      }
    })
  }
  getFirewallIdsIpsSetting() {
    this.systemId = this.deviceId;
    this._service.getService(this._service.API_URL.getDeskProtectionSettingsAPI + this.systemId).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.firewallProtection = response.data.firewallProtection;
        this.idsIpsProtection = response.data.idsIpsProtection;
        this.savedProtectionSettings = response.data;
        this.protectionSettingLastUpdated = response.data.lastUpdatedDate;
        this.setControlStates(response.data);
        if (this.firewallProtection || this.idsIpsProtection) {
          this.firewallIdsIps = true;
        } else {
          this.firewallIdsIps = false;
        }
      } else {
        this.isLoading = false;
        if (response.status.msgCode === "DESKTOP_SETTINGS_NOT_FOUND") {
          this.firewallIdsIps = false;
          this.firewallProtection = false;
          this.idsIpsProtection = false;
          this.savedProtectionSettings.firewallProtection = false;
          this.savedProtectionSettings.idsIpsProtection = false;
        }
      }
    })
  }
  checkBeforePublish() {
    $('#publishPopup').modal('show');
  }
  toggleOn: boolean = false;
  showPremiumUpgradeMsg() {
    if (this.premiumMsg && this.premiumMsg != '') {
      this._toaster.error('', this.premiumMsg);
    }
  }
  closeSuccessPinModal() {
    $("#savePopup").modal("show");
  }

  get restrictWebCategoryArray(): FormArray {
    return this.parentalControlForm.get('restrictWebCategoryList') as FormArray;
  }

  get restrictAppCategoryArray(): FormArray {
    return this.parentalControlForm.get('restAppCatergoryList') as FormArray;
  }

  blockParticularWebList: { url: string, blockSubdomain: boolean }[] = [];
  excludeParticularWebList: { url: string, blockSubdomain: boolean }[] = [];
  recordExist: any;
  blockSite: string;
  excludeSite: string;

  parentalControlForm: FormGroup = new FormGroup({
    systemId: new FormControl(''),
    user: new FormControl(''),
    featureStatus: new FormControl(),
    restrictWebCategoryList: new FormArray([]),
    excludedWebsiteList: new FormArray([]),
    restAppCatergoryList: new FormArray([]),
    blockParticularWebsiteList: new FormArray([]),
    allowedAppsList: new FormArray([]),
    restrictAppList: new FormArray([]),
    accessToInternet: new FormControl(),
    scheduleType: new FormControl(),
    sundSlot: new FormControl(''),
    monSlot: new FormControl(''),
    tuesSlot: new FormControl(''),
    wedSlot: new FormControl(''),
    thursSlot: new FormControl(''),
    fridSlot: new FormControl(''),
    satSlot: new FormControl(''),
    fromTime: new FormControl(''),
    toTime: new FormControl(''),
  });

  parentalControlValidation() {
    this.parentalControlForm = this._formBuilder.group(
      {
        systemId: [],
        restrictCategoryList: this._formBuilder.array(this.restrictWebCategoryList),
        excludedWebsiteList: this._formBuilder.array([]),
        restAppCatergoryList: this._formBuilder.array([this.restAppCatergoryList]),
        blockParticularWebsiteList: this._formBuilder.array([]),
        allowedAppsList: [],
        restrictAppList: [],
        accessToInternet: this._formBuilder.control,
        scheduleType: this._formBuilder.control,
        sundSlot: this._formBuilder.control,
        monSlot: this._formBuilder.control,
        tuesSlot: this._formBuilder.control,
        wedSlot: this._formBuilder.control,
        thursSlot: this._formBuilder.control,
        fridSlot: this._formBuilder.control,
        satSlot: this._formBuilder.control,
      },
    );
  }

  openTabs(tabName: string) {
    if (tabName === 'INTERNETBROWSING') {
      this.internetTab = true;
      this.appTab = false;
      this.schedularTab = false;
    } else if (tabName === 'APPLICATIONACCESS') {
      this.internetTab = false;
      this.appTab = true;
      this.schedularTab = false;
    }
    else {
      this.internetTab = false;
      this.appTab = false;
      this.schedularTab = true;
    }
  }

  setControlStates(data: any) {
    this.featureToggleMap.set("SMART_PARENTAL_SETTINGS", this.isParentalOn);
    this.featureToggleMap.set("RANSOMWARE_PROTECTION", data?.ransomwareProtection);
    this.featureToggleMap.set("IDS_IPS_SETTINGS", (data.firewallProtection || data?.idsIpsProtection));
    this.featureToggleMap.set("VIRUS_PROTECTION", data?.virusProtection);
  }

  getParentalSettings() {
    try {
      this.systemId = this.deviceId;
      this._service.getService(this._service.API_URL.getDeskParentalSettingsAPI + this.systemId).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.parentalLastUpdated = response.data.lastUpdatedDate;
          this.lastConncetdDate = response.data.lastConnectedDate;
          this.savedParentalCntrlSettings = response.data;
          this.setParentalControlSettings(response.data);
        } else {
          this.isLoading = false;
          this.parentalJsonString = null;
          if (response.status.msgCode != "DESKTOP_PARENTAL_SETTING_NOT_SUPPORTED") {
            this._toaster.error('', response.status.message);
          }
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  private setParentalControlSettings(data: any) {
    this.parentalJsonString = data;
    this.isParentalOn = data.isParentalControlOn;
    this.featureToggleMap.set("SMART_PARENTAL_SETTINGS", this.isParentalOn);
    this.parentalDtoList = [];
    this.userList = data.users.map((item: any) => item.user);
    this.selectedValue = this.userList[0];
    this.currentUser = this.userList[0];
    this.renewalUrl = data?.renewalUrl;
    if (data.role === "SUPER_ADMIN") {
      this.userRole = this.translateService.instant("MANAGEUSER.SUPERADMIN");
    } else if (data.role === "ADMIN") {
      this.userRole = this.translateService.instant("MANAGEUSER.ADMIN");
    } else if (data.role === "MEMBERS") {
      this.userRole = this.translateService.instant("MANAGEUSER.MEMBER");
    } else if (data.role === "CHILD") {
      this.userRole = this.translateService.instant("MANAGEUSER.CHILD");
    } else {
      this.userRole = "";
    }
    data.users.forEach((user: any) => {
      const parentalDto: SystemParentalDto = new SystemParentalDto();
      parentalDto.user = user.user;
      parentalDto.configured = user.configured;
      parentalDto.webCatList = user.settings.internetBrowsing.webCatList;
      parentalDto.blockWebsites = user.settings.internetBrowsing.blockWebsites;
      parentalDto.excludeWebsites = user.settings.internetBrowsing.excludeWebsites;
      parentalDto.appCategoryList = user.settings.applicationAccess.appCategoryList;
      parentalDto.blockApplications = user.settings.applicationAccess.blockApplications;
      parentalDto.excludeApplications = user.settings.applicationAccess.excludeApplications;
      parentalDto.pcAccessaccessToInternet = user.settings?.pcAccessControl?.accessToInternet;
      parentalDto.scheduleType = user.settings.pcAccessControl?.scheduleSelection;
      parentalDto.hoursSlot = user.settings.pcAccessControl?.hoursSlot;
      this.slots = {};
      user.settings.pcAccessControl?.timeSlots.forEach((timeslot: any) => {
        const dayKey = this.days[timeslot.day - 1];
        if (!this.slots[dayKey.id]) {
          this.slots[dayKey.id] = [];
        }

        this.slots[dayKey.id].push({
          from: this.times[timeslot.slot.from],
          to: this.times[timeslot.slot.to],
        });
      });
      parentalDto.timeSlots = this.slots;
      this.parentalDtoList.push(parentalDto);
    });
    this.mapJsonStringtoDto(this.parentalDtoList[0]);
    console.log(this.parentalJsonString);
  }

  checkIfConfigured() {
    const dto = this.parentalDtoList.find(
      (dto: any) => dto.user === this.currentUser.toString()
    );

    if (dto) {
      dto.configured = true;
    }
  }
  mapJsonStringtoDto(data: any) {
    this.restrictWebCategoryList = data.webCatList;
    const formGroups = this.restrictWebCategoryList.map((item: any) =>
      this._formBuilder.group({
        key: [item.key],
        id: [item.id],
        value: [item.value],
        isChecked: [item.isChecked]
      })
    );
    const formArray = this._formBuilder.array(formGroups);
    this.parentalControlForm.setControl('restrictWebCategoryList', formArray);
    this.blockParticularWebList = data.blockWebsites;
    this.excludeParticularWebList = data.excludeWebsites;

    this.restAppCatergoryList = data.appCategoryList;
    const appformGroups = this.restAppCatergoryList.map((item: any) =>
      this._formBuilder.group({
        key: [item.key],
        id: [item.id],
        value: [item.value],
        isChecked: [item.isChecked]
      })
    );
    const appformArray = this._formBuilder.array(appformGroups);
    this.parentalControlForm.setControl('restAppCatergoryList', appformArray);
    this.blockedAppList = data.blockApplications;
    this.excludedAppList = data.excludeApplications;
    const unslectedWebCat = this.restrictWebCategoryList.filter((cat: any) => cat.isChecked == false);
    unslectedWebCat.length != 0 ? this.allWebChecked = false : this.allWebChecked = true;
    const unslectedAppCat = this.restAppCatergoryList.filter((cat: any) => cat.isChecked == false);
    unslectedAppCat.length != 0 ? this.allAppChecked = false : this.allAppChecked = true;
    this.parentalControlForm.get('accessToInternet')?.setValue(data?.pcAccessaccessToInternet?.toString());
    this.parentalControlForm.get('scheduleType')?.setValue(data?.scheduleType?.toString());
    data?.pcAccessaccessToInternet != 1 ? this.parentalControlForm.get('scheduleType')?.enable() : this.parentalControlForm.get('scheduleType')?.disable();
    if (data?.pcAccessaccessToInternet?.toString() != "1") {
      this.enableSchedular = true;
    }
    else {
      this.enableSchedular = false;
    }
    if (data.scheduleType === 1) {
      this.selecetedTimeslot = true;
    }
    else {
      this.selecetedTimeslot = false;
    }
    this.parentalControlForm.get('sundSlot')?.setValue(data?.hoursSlot?.filter((slot: { day: number; }) => slot.day === 1)?.map((slot: { hours: number; }) => slot.hours));
    this.parentalControlForm.get('sundSlot')?.setValue(this.parentalControlForm.value?.sundSlot.length != 0 ? this.parentalControlForm.value?.sundSlot : [24]);
    this.parentalControlForm.get('monSlot')?.setValue(data?.hoursSlot?.filter((slot: { day: number; }) => slot.day === 2)?.map((slot: { hours: number; }) => slot.hours));
    this.parentalControlForm.get('monSlot')?.setValue(this.parentalControlForm.value?.monSlot.length != 0 ? this.parentalControlForm.value?.monSlot : [24]);
    this.parentalControlForm.get('tuesSlot')?.setValue(data.hoursSlot?.filter((slot: { day: number; }) => slot.day === 3)?.map((slot: { hours: number; }) => slot.hours));
    this.parentalControlForm.get('tuesSlot')?.setValue(this.parentalControlForm.value?.tuesSlot.length != 0 ? this.parentalControlForm.value?.tuesSlot : [24]);
    this.parentalControlForm.get('wedSlot')?.setValue(data.hoursSlot?.filter((slot: { day: number; }) => slot.day === 4)?.map((slot: { hours: number; }) => slot.hours));
    this.parentalControlForm.get('wedSlot')?.setValue(this.parentalControlForm.value?.wedSlot.length != 0 ? this.parentalControlForm.value?.wedSlot : [24]);
    this.parentalControlForm.get('thursSlot')?.setValue(data.hoursSlot?.filter((slot: { day: number; }) => slot.day === 5)?.map((slot: { hours: number; }) => slot.hours));
    this.parentalControlForm.get('thursSlot')?.setValue(this.parentalControlForm.value?.thursSlot.length != 0 ? this.parentalControlForm.value?.thursSlot : [24]);
    this.parentalControlForm.get('fridSlot')?.setValue(data.hoursSlot?.filter((slot: { day: number; }) => slot.day === 6)?.map((slot: { hours: number; }) => slot.hours));
    this.parentalControlForm.get('fridSlot')?.setValue(this.parentalControlForm.value?.fridSlot.length != 0 ? this.parentalControlForm.value?.fridSlot : [24]);
    this.parentalControlForm.get('satSlot')?.setValue(data.hoursSlot?.filter((slot: { day: number; }) => slot.day === 7)?.map((slot: { hours: number; }) => slot.hours));
    this.parentalControlForm.get('satSlot')?.setValue(this.parentalControlForm.value?.satSlot.length != 0 ? this.parentalControlForm.value?.satSlot : [24]);
    this.slots = data?.timeSlots;
    this.cdr.detectChanges();
  }

  onUserChange(event: any) {
    const data = this.parentalDtoList.find((dto: any) => dto.user === event.target.value);
    this.saveParentingSetting();
    this.mapJsonStringtoDto(data);
    this.currentUser = data?.user;
    this.recordExistBlock = null;
    this.cdr.detectChanges();
  }

  convertSlots(data: any) {
    const finalString = Array.isArray(data)
      ? data.join(', ')
      : (typeof data === 'string' ? data : '24');
    return finalString;
  }

  saveParentingSetting() {
    const parentalDto: any = this.parentalDtoList.find((dto: any) => dto.user === this.currentUser.toString());
    parentalDto.webCatList = this.parentalControlForm.value.restrictWebCategoryList;
    parentalDto.blockWebsites = this.blockParticularWebList;
    parentalDto.excludeWebsites = this.excludeParticularWebList;
    parentalDto.appCategoryList = this.parentalControlForm.value?.restAppCatergoryList;
    parentalDto.appCategoryList = this.parentalControlForm.value?.restAppCatergoryList;
    parentalDto.scheduleType = Number(this.parentalControlForm.value?.scheduleType);
    parentalDto.pcAccessaccessToInternet = Number(this.parentalControlForm.value?.accessToInternet);
    parentalDto.timeSlots = this.slots;
    this.dayTimeslotsList = new Set();
    if (this.isParentalOn) {
      this.dayTimeslotsList.add({ day: 1, hours: Number(this.convertSlots(this.parentalControlForm.value?.sundSlot)) });
      this.dayTimeslotsList.add({ day: 2, hours: Number(this.convertSlots(this.parentalControlForm.value?.monSlot)) });
      this.dayTimeslotsList.add({ day: 3, hours: Number(this.convertSlots(this.parentalControlForm.value?.tuesSlot)) });
      this.dayTimeslotsList.add({ day: 4, hours: Number(this.convertSlots(this.parentalControlForm.value?.wedSlot)) });
      this.dayTimeslotsList.add({ day: 5, hours: Number(this.convertSlots(this.parentalControlForm.value?.thursSlot)) });
      this.dayTimeslotsList.add({ day: 6, hours: Number(this.convertSlots(this.parentalControlForm.value?.fridSlot)) });
      this.dayTimeslotsList.add({ day: 7, hours: Number(this.convertSlots(this.parentalControlForm.value?.satSlot)) });
      parentalDto.hoursSlot = Array.from(this.dayTimeslotsList);
    }
  }

  blockParticluarWebsiteSiteUrl() {
    this.recordExistBlock = null;
    const regex = /[@#$%^&]/;
    if (!this.blockSite || this.blockSite.trim() === '') {
      this._toaster.error(this.translateService.instant("TOSTRMSGS.QH_TOSTR_ENTER_VALID_URL"));
      return false;
    } else if (regex.test(this.blockSite)) {
      this._toaster.error(this.translateService.instant("TOSTRMSGS.QH_TOSTR_ENTER_VALID_URL"));
      return false;
    } else {
      const webData = this.blockParticularWebList.find((x: any) => x.url === this.blockSite);
      const webData1 = this.excludeParticularWebList.find((x: any) => x.url === this.blockSite);
      if (webData) {
        this.recordExistBlock = this.enJsonData[0].BLOCCKEDURLALREADYADDED;
      } else if (webData1) {
        this.recordExistBlock = this.enJsonData[0].EXCLUDEURLALREADYADDED;
      }
      else {
        this.blockParticularWebList.push({
          url: this.blockSite,
          blockSubdomain: this.isincludeSubDomain,
        });
        if (this.blockParticularWebList?.length != 0) {
          this.parentalControlForm.markAsDirty()
        }
        this.isUnsavedPS = true;
      }
      this.blockSite = ''
      return true;
    }
  }

  excludeParticluarWebsiteSiteUrl() {
    this.excludeExist = null;
    this.recordExist = null;
    const regex = /[@#$%^&]/;
    if (!this.excludeSite || this.excludeSite.trim() === '') {
      this._toaster.error(this.translateService.instant("TOSTRMSGS.QH_TOSTR_ENTER_VALID_URL"));
      return false;
    } else if (regex.test(this.excludeSite)) {
      this._toaster.error(this.translateService.instant("TOSTRMSGS.QH_TOSTR_ENTER_VALID_URL"));
      return false;
    } else {
      const webData = this.excludeParticularWebList.find((x: any) => x.url === this.excludeSite);
      const webData1 = this.blockParticularWebList.find((x: any) => x.url === this.excludeSite);
      if (webData) {
        this.recordExist = this.enJsonData[0].EXCLUDEURLALREADYADDED;
      } else if (webData1) {
        this.recordExist = this.enJsonData[0].BLOCCKEDURLALREADYADDED;
      } else {
        this.excludeParticularWebList.push({
          url: this.excludeSite,
          blockSubdomain: this.isExcludedSubDomain,
        });
        if (this.excludeParticularWebList?.length != 0) {
          this.parentalControlForm.markAsDirty()
        }
        this.isUnsavedPS = true;
      }
      this.excludeSite = ''
      return true;
    }
  }

  deleteSelectedIndex(item: any) {
    if (!this.isParentalOn) {
      return;
    }
    this.recordExist = null;
    let index = this.blockParticularWebList.indexOf(item);
    this.blockParticularWebList.splice(index, 1);
    this.parentalControlForm.markAsDirty();
  }

  deleteExludedURLByIndex(item: any) {
    if (!this.isParentalOn) {
      return;
    }
    this.recordExist = null;
    let index = this.excludeParticularWebList.indexOf(item);
    this.excludeParticularWebList.splice(index, 1);
    this.parentalControlForm.markAsDirty();
  }
  onIncludeSubDomain(event: any) {
    this.isincludeSubDomain = event.target.checked;
  }

  onExcludeSubDomain(event: any) {
    this.isExcludedSubDomain = event.target.checked;
  }

  onWebCatClick(event: any, data: any, type: string) {
    data.isChecked = event.target.checked;
    this.isUnsavedPS = true;
    if (type == 'single') {
      if (event.target.checked && this.allWebChecked) {
        this.webCatList.add(data.id);
      }
      else {
        this.allWebChecked = false
        this.webCatList.delete(data.id)
        this.individualWebChecked = this.webCatList.size > 0
      }
      this.parentalControlForm.markAsDirty()
      this.allWebChecked = true;
      let blockedAppCategoriesList: any[] = this.parentalControlForm.get('restrictWebCategoryList')?.value;
      blockedAppCategoriesList.forEach(i => {
        if (!i.isChecked) {
          this.allWebChecked = false;
        }
      });
    }
    else {
      if (event.target.checked) {
        let blockedAppCategoriesList: any[] = this.parentalControlForm.get('restrictWebCategoryList')?.value;
        blockedAppCategoriesList.forEach(i => i.isChecked = true);
        this.parentalControlForm.controls['restrictWebCategoryList'].setValue(blockedAppCategoriesList);

        this.parentalControlForm.updateValueAndValidity();
        this.allWebChecked = true;
        this.individualWebChecked = true;
        data.forEach((element: any) => {
          this.allWebChecked = true
          this.individualWebChecked = true
          this.webCatList.add(element.id);
        })
      }
      else {
        let blockedAppCategoriesList: any[] = this.parentalControlForm.get('restrictWebCategoryList')?.value;
        blockedAppCategoriesList.forEach(i => i.isChecked = false);
        this.parentalControlForm.controls['restrictWebCategoryList'].setValue(blockedAppCategoriesList);

        this.parentalControlForm.updateValueAndValidity();
        this.allWebChecked = false;
        this.individualWebChecked = false;
        data.forEach((element: any) => {
          this.individualWebChecked = false
          this.allWebChecked = false
          this.webCatList.delete(element.id);
        })
      }
      this.parentalControlForm.markAsDirty()
    }
  }

  saveDeskParentalSettings() {
    this.saveParentingSetting();
    this.parentalDtoList.forEach((dto: any) => {
      const newTimeSlots: Record<string, any[]> = {};
      Object.entries(dto.timeSlots).forEach(([day, slot]: any) => {
        newTimeSlots[day.toLowerCase()] = slot;
      })
      dto.timeSlots = newTimeSlots;
    });
    this.systemId = this.deviceId;
    this.parentalSettingsPayload.parenatlSettingList = this.parentalDtoList;
    this.parentalSettingsPayload.applyTo = this.currentUser === 'All Users' ? 1 : 2;
    if (this.currentUser === 'All Users') {
      this.parentalSettingsPayload.isAllUsersConfigured = true;
    }
    this.parentalSettingsPayload.systemIds = this.systemId;
    this.parentalSettingsPayload.isParentalControlOn = this.isParentalOn;
    this.checkIfConfigured();
    this.isLoading = true;
    this.isUnsavedPS = false;
    this._service.postService(this._service.API_URL.saveDesktopParentalSetting, this.parentalSettingsPayload).subscribe((response: any) => {
      if (response && response.status.code === 200) {
        this.isLoading = false;
        this._toaster.success(this.saveSuccessMessage);
      }
      else {
        this.isLoading = false;
        this._toaster.error(response.data?.message);
      }
    });
  }

  onBlockApplicationClick(event: any, data: any, type: string) {
    data.isChecked = event.target.checked;
    this.isUnsavedPS = true;
    if (type == 'single') {
      if (event.target.checked && this.allAppChecked) {
        this.appCatList.add(data.id);
      }
      else {
        this.allAppChecked = false
        this.appCatList.delete(data.id)
        this.individualAppChecked = this.appCatList.size > 0
      }
      this.parentalControlForm.markAsDirty()
      this.allAppChecked = true;
      let blockedWebCategoriesList: any[] = this.parentalControlForm.get('restAppCatergoryList')?.value;
      blockedWebCategoriesList.forEach(i => {
        if (!i.isChecked) {
          this.allAppChecked = false;
        }
      });
    }
    else {
      if (event.target.checked) {
        let blockedWebCategoriesList: any[] = this.parentalControlForm.get('restAppCatergoryList')?.value;
        blockedWebCategoriesList.forEach(i => i.isChecked = true);
        this.parentalControlForm.controls['restAppCatergoryList'].setValue(blockedWebCategoriesList);

        this.parentalControlForm.updateValueAndValidity();
        this.allAppChecked = true
        this.individualAppChecked = true
        data.forEach((element: any) => {
          this.allAppChecked = true
          this.individualAppChecked = true
          this.appCatList.add(element.id);
        })
      }
      else {
        let blockedWebCategoriesList: any[] = this.parentalControlForm.get('restAppCatergoryList')?.value;
        blockedWebCategoriesList.forEach(i => i.isChecked = false);
        this.parentalControlForm.controls['restAppCatergoryList'].setValue(blockedWebCategoriesList);

        this.parentalControlForm.updateValueAndValidity();
        this.individualAppChecked = false
        this.allWebChecked = false
        data.forEach((element: any) => {
          this.individualAppChecked = false
          this.allWebChecked = false
          this.appCatList.delete(element.id);
        })
      }
      this.parentalControlForm.markAsDirty()
    }
  }

  onScheduleChange(event: any) {
    this.parentalControlDto.accessToInternet = event.target.value;
    if (event.target.value != 1) {
      this.parentalControlForm.get('scheduleType')?.enable();
      this.enableSchedular = true;
    } else {
      this.parentalControlForm.get('scheduleType')?.disable();
      this.enableSchedular = false;
    }
    this.isUnsavedPS = true;
    const parentalDto: any = this.parentalDtoList.find((dto: any) => dto.user === this.currentUser.toString());
    parentalDto.pcAccessaccessToInternet = Number(this.parentalControlForm.value?.accessToInternet);
  }

  onAccessTypeChange(event: any) {
    this.parentalControlDto.scheduleType = event.target.value;
    if (event.target.value != "1") {
      this.selecetedTimeslot = false;
    }
    else {
      this.selecetedTimeslot = true;
    }
    this.isUnsavedPS = true;
    const parentalDto: any = this.parentalDtoList.find((dto: any) => dto.user === this.currentUser.toString());
    parentalDto.scheduleType = Number(this.parentalControlForm.value?.scheduleType);
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.multiselect-wrapper')) {
      this.dropdownOpen = false;
    }
  }

  onDayToggle(event: any): void {
    const day = event.target.value;
    if (event.target.checked) {
      this.selectedDays.push(day);
    } else {
      this.selectedDays = this.selectedDays.filter(d => d !== day);
    }
    this.allSelected = this.selectedDays.length === this.days.length;
  }

  toggleSelectAll(): void {
    if (this.allSelected) {
      this.selectedDays = [];
    } else {
      this.selectedDays = this.days.map(day => day.id);
    }
    this.allSelected = !this.allSelected;
  }

  addTimeSlot() {
    const { fromTime, toTime } = this.timeSlotForm.value;
    const fromIndex = this.times.indexOf(fromTime);
    const toIndex = this.times.indexOf(toTime);

    if (fromIndex === -1 || toIndex === -1 || fromIndex >= toIndex) {
      this._toaster.error("Please Select valid To time");
      return;
    }

    for (const day of this.selectedDays) {
      if (!this.slots[day]) {
        this.slots[day] = [];
      }

      for (let i = fromIndex; i < toIndex; i++) {
        const slot: TimeSlot = { from: this.times[i], to: this.times[i + 1] };

        const exists = this.slots[day].some(
          s => s.from === slot.from && s.to === slot.to
        );

        if (!exists) {
          this.slots[day].push(slot);
        }
      }
    }
    this.isUnsavedPS = true;
    this.timeSlotForm.reset();
    this.timeSlotForm.patchValue({ fromTime: '' });
    this.timeSlotForm.patchValue({ toTime: '' });
    this.selectedDays = [];
  }

  onSlotChange() {
    this.isUnsavedPS = true;
  }
  removeTimeSlot(day: string, slotToRemove: TimeSlot) {
    if (!this.isParentalOn) {
      return;
    }
    this.slots[day] = this.slots[day].filter(
      s => !(s.from === slotToRemove.from && s.to === slotToRemove.to)
    );
    if (this.slots[day].length === 0) {
      delete this.slots[day];
    }
  }

  isTimeDisabled(time: string, type: 'from' | 'to') {
    let disabled = false;
    for (const day of this.selectedDays) {
      const slotsForDay = this.slots[day] || [];

      for (const slot of slotsForDay) {
        if (type === 'from' && slot.from === time) {
          disabled = true;
        }
        if (type === 'to' && (slot.to === time)) {
          disabled = true;
        }
      }
    }
    return disabled;
  }

  getSortedSlots(slots: TimeSlot[]) {
    return slots?.slice().sort((a, b) => {
      const timeToMinutes = (time: string): number => {
        const [h, mPart] = time.split(':');
        let [minutes, meridian] = [mPart.slice(0, 2), mPart.slice(3)];
        let hour = parseInt(h, 10);
        if (meridian === 'PM' && hour !== 12) hour += 12;
        if (meridian === 'AM' && hour === 12) hour = 0;
        return hour * 60 + parseInt(minutes, 10);
      };

      return timeToMinutes(a.from) - timeToMinutes(b.from);
    });
  }

  submitSchedule() {
    if (!this.slots || Object.keys(this.slots).length === 0) {
      console.warn('No slots selected.');
      return;
    }

    const result = Object.entries(this.slots).map(([day, slots]) => ({
      day: this.dayMap[day] || 0,
      slots: this.getSortedSlots(slots).map(slot => ({
        from: this.convertTo24Hour(slot.from),
        to: this.convertTo24Hour(slot.to)
      }))
    }));
  }

  convertTo24Hour(time: string) {
    const [hourPart, minuteMeridian] = time.split(':');
    const hour = parseInt(hourPart, 10);
    const meridian = minuteMeridian.slice(3);

    let h = hour;

    if (meridian === 'AM' && hour === 12) {
      h = 0;
    } else if (meridian === 'PM' && hour !== 12) {
      h = hour + 12;
    }

    return `${h.toString()}`;
  }

  onProtectionSettingToggleChange(event: any, type: any) {
    const checked = event.target.checked;
    if (!checked) {
      this.title = this.translateService.instant("SETTINGS.PROTECTION_MODAL." + type + ".TITLE");
      this.description = this.translateService.instant("SETTINGS.PROTECTION_MODAL." + type + ".DESCRIPTION");

      if (type === 'RANSOMEWARE_PROTECTION') {
        this.ransomwareProtection = false;
        this.isUnsavedRans = true;
        this.featureToggleMap.set("RANSOMWARE_PROTECTION", this.ransomwareProtection);
        $("#protectionSettingModal").modal("show");
      } else if (type === 'VIRUS_PROTECTION') {
        this.virusProtection = false;
        this.isUnsavedVirus = true;
        this.featureToggleMap.set("VIRUS_PROTECTION", this.virusProtection);
        $("#protectionSettingModal").modal("show");
      }
    } else {
      if (type === 'RANSOMEWARE_PROTECTION') {
        this.ransomwareProtection = true;
        this.isUnsavedRans = true;
        this.featureToggleMap.set("RANSOMWARE_PROTECTION", this.ransomwareProtection);
      } else if (type === 'VIRUS_PROTECTION') {
        this.virusProtection = true;
        this.isUnsavedVirus = true;
        this.featureToggleMap.set("VIRUS_PROTECTION", this.virusProtection);
      }
    }
  }
  onProtectionModalCancel() {
    if (this.selectedI === 2) {
      this.ransomwareProtection = true;
      this.featureToggleMap.set("RANSOMWARE_PROTECTION", this.ransomwareProtection);
    } else if (this.selectedI === 3) {
      this.virusProtection = true;
      this.featureToggleMap.set("VIRUS_PROTECTION", this.virusProtection);
    }
    $("#protectionSettingModal").modal("hide");
  }
  onProtectionModalSave() {
    if (this.selectedI === 2) {
      this.ransomwareProtection = false;
      this.ransomewareProtectionOnValue = this.selectedTime;
      this.featureToggleMap.set("RANSOMWARE_PROTECTION", this.virusProtection);
    } else if (this.selectedI === 3) {
      this.virusProtection = false;
      this.virusProtectionOnValue = this.selectedTime;
      this.featureToggleMap.set("VIRUS_PROTECTION", this.virusProtection);

    }
    $("#protectionSettingModal").modal("hide");
  }
  onFirewallToggleChange(event: any) {
    const isChecked = event.target.checked;
    this.isUnsavedFire = true;
    if (isChecked) {
      this.firewallProtection = true;
    } else {
      this.firewallProtection = false;
    }
    this.checkFirewallIdsIpsToggle();
  }
  onIdsIpsToggleChange(event: any) {
    const isChecked = event.target.checked;
    this.isUnsavedFire = true;
    if (isChecked) {
      this.idsIpsProtection = true;
    } else {
      this.idsIpsProtection = false;
    }
    this.checkFirewallIdsIpsToggle();
  }
  checkFirewallIdsIpsToggle() {
    if (this.firewallProtection === false && this.idsIpsProtection === false) {
      this.firewallIdsIps = false;
      this.featureToggleMap.set("IDS_IPS_SETTINGS", this.firewallIdsIps);
    } else {
      this.firewallIdsIps = true;
      this.featureToggleMap.set("IDS_IPS_SETTINGS", this.firewallIdsIps);
    }
  }
  onFirewallIdsIpsToggleChange(event: any) {
    const isChecked = event.target.checked;
    this.isUnsavedFire = true;
    if (!isChecked) {
      this.firewallIdsIps = false;
      this.firewallProtection = false;
      this.idsIpsProtection = false;
      this.featureToggleMap.set("IDS_IPS_SETTINGS", this.idsIpsProtection);
    } else {
      this.firewallIdsIps = true;
      this.firewallProtection = true;
      this.idsIpsProtection = true;
      this.featureToggleMap.set("IDS_IPS_SETTINGS", this.idsIpsProtection);
    }
  }

  onResetCancel() {
    $("#resetSettingsModal").modal("hide");
  }

  onReset() {
    if (this.selectedI === 0) {
      this.setParentalControlSettings(this.savedParentalCntrlSettings);
      this.isUnsavedPS = false;
    } else if (this.selectedI === 1) {
      this.firewallProtection = this.savedProtectionSettings?.firewallProtection;
      this.idsIpsProtection = this.savedProtectionSettings?.idsIpsProtection;
      this.isUnsavedFire = false;
      this.checkFirewallIdsIpsToggle();
    } else if (this.selectedI === 2) {
      this.ransomwareProtection = this.savedProtectionSettings?.ransomwareProtection;
      this.ransomewareProtectionOnValue = this.savedProtectionSettings?.ransomwareProtectionOnValue;
      this.isUnsavedRans = false;
    } else if (this.selectedI === 3) {
      this.virusProtection = this.savedProtectionSettings?.virusProtection;
      this.virusProtectionOnValue = this.savedProtectionSettings?.virusProtectionOnValue;
      this.isUnsavedVirus = false;
    }
    $("#resetSettingsModal").modal("hide");
  }

  onResetBtnClick() {
    $("#resetSettingsModal").modal("show");
  }
  checkBeforGoBack() {
    if (this.isUnsavedPS || this.isUnsavedFire || this.isUnsavedRans || this.isUnsavedVirus) {
      this.openUnsavedPopupBack();
    } else {

      this.goBack();
    }
  }
  goBack() {
    $("#BackUnsavedSettingsPopup").modal("hide");
    this.router.navigateByUrl('/home/manage-device');
    this.router.navigate(['/home/manage-device'], {
      queryParams: {
        userId: this.selectedUserId, // Assuming selectedUserId is stored in manage-device-control
        deviceId: this.deviceId, // Assuming deviceId is the ID of the current device
      },
    });
  }

  navigateToRenewSite() {
    const url = this.renewalUrl + '?prdkey=' + this.productKey;
    const newTab = window.open(url, '_blank');
  }

  openupdatePopup() {
    $("#UpdateSettingsPopup").modal("show");
  }

  closeupdatepopUp() {
    $("#UpdateSettingsPopup").modal("hide");
  }
  openupdateParentalPopup() {
    $("#selectDevicePopupParental").modal("show");
  }

  closeupdateParentalpopUp() {
    $("#selectDevicePopupParental").modal("hide");
  }

  openUnsavedPopup() {
    $("#UnsavedSettingsPopup").modal("show");
  }

  closeUnsavedPopup() {
    $("#UnsavedSettingsPopup").modal("hide");
    this.isUnsavedPS = false;
    this.isUnsavedFire = false;
    this.isUnsavedRans = false;
    this.isUnsavedVirus = false;
    this.selectedIndex(this.nextSelecctedI, this.nextData);
  }

  closeUnsavedPopup2() {
    $("#UnsavedSettingsPopup").modal("hide");
  }

  closeUnsavedPopupBack2() {
    $("#BackUnsavedSettingsPopup").modal("hide");
  }

  openUnsavedPopupBack() {
    $("#BackUnsavedSettingsPopup").modal("show");
  }

  stayWithSameTab() {
    $("#UnsavedSettingsPopup").modal("hide");
    $("#BackUnsavedSettingsPopup").modal("hide");
  }



  openselectDevicePopup() {
    $("#UpdateSettingsPopup").modal("hide");
    if (this.selectedI != 0) {
      $("#selectDevicePopup").modal("show");
    } else {
      $("#selectDevicePopupParental").modal("show");
    }
  }

  closeselectDevicepopUp() {
    $("#selectDevicePopup").modal("hide");
  }

  openSuccessAppliedPopup() {
    if (this.selectedI != 0) {
      $("#selectDevicePopup").modal("hide");
    } else {
      $("#selectDevicePopupParental").modal("hide");
    }
    $("#SuccessAppliedModal").modal("show");
  }

  closeSuccessAppliedpopUp() {
    $("#SuccessAppliedModal").modal("hide");
  }

  onCheckboxChange(e: any) {
    const deviceArray: FormArray = this.deviceForm.get('deviceIds') as FormArray;

    if (e.target.checked) {
      deviceArray.push(this._formBuilder.control(e.target.value));
      if (deviceArray?.length > 0) {
        this.disableApply = true;
      }
      else {
        this.disableApply = false;
      }

    } else {
      const index = deviceArray.controls.findIndex(x => x.value === e.target.value);
      deviceArray.removeAt(index);
      if (deviceArray?.length > 0) {
        this.disableApply = true;
      }
      else {
        this.disableApply = false;
      }
    }
  }

  onApplySettingsToDevices() {

    try {
      this.otherDeviceSettings = new OtherDeviceSettings();
      this.otherDeviceSettings.deviceId = this.systemId;
      this.otherDeviceSettings.otherDevices = this.deviceForm.value?.deviceIds;
      this.otherDeviceSettings.systemRequestType = this.SettingsType[this.selectedI];
      this.otherDeviceSettings.deviceType = CommonEnums.SYSTEM,
        this.selectedSystems = [];
      this.deviceForm.value?.deviceIds.forEach((deviceId: any) => {
        this.selectedSystems.push(this.otherDevices.find(device => device.id == deviceId));
      })

      this._service.postService(this._service.API_URL.applySettingsToOtherDesktops, this.otherDeviceSettings).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toaster.success('', response.status.message);
          this.openSuccessAppliedPopup();
        } else {
          this.isLoading = false;
          this._toaster.error('', response.status.message)
        }
      })
    } catch {
      this.isLoading = false;
    }


  }
  openMyIndexRenewLicense(system: any) {
    let prdkey = '';
    let url = '';

    if (this.userTimezone == 'Asia/Kolkata' || this.userTimezone == 'Asia/Calcutta') {
      if (this.selectedLanguage && this.selectedLanguage !== 'en') {
        prdkey = this.crwSupportedProductTypes.includes(system?.productType) ? system.productKey : '';
        url = `${system.productLink}?prdkey=${prdkey}&QVER=${system.buildVersion}`;
      } else {
        prdkey = this.crwSupportedProductTypes.includes(system?.productType)
          ? system.encryptedProductKey : system.productKey;
        url = `${system.productLink}?prdkey=${prdkey}`;
      }
    } else {
      prdkey = this.crwSupportedProductTypes.includes(system?.productType)
        ? system.productKey : '';
      url = `${this.interntionalUrl}?prdkey=${prdkey}&QVER=${system.productVersion}`;
    }
    const newTab = window.open(url, '_blank');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== system.crwDomainUrl) return;

      if (event.data === 'payment_success') {
        window.removeEventListener('message', messageHandler);
        this.handlePaymentSuccess(system.productKey);
      } else {
        window.removeEventListener('message', messageHandler);
      }
    };

    window.addEventListener('message', messageHandler);
    // Poll to detect if the user closes the tab without completing payment
    const tabWatcher = setInterval(() => {
      if (newTab?.closed) {
        clearInterval(tabWatcher);
        window.removeEventListener('message', messageHandler);
      }
    }, 500); // Check every 500ms
  }

  handlePaymentSuccess(productKey: string): void {
    console.log('handlePaymentSuccess ::', productKey);
    this.getDesktopProductKeyDetails(productKey);
  }
  getDesktopProductKeyDetails(productKey: string): void {
    this.isLoading = true;
    console.log('getDesktopProductKeyDetails ::', productKey);
    try {
      this._service
        .getService(
          this._service.API_URL.getDesktopProductKeyDetails +
          '?productKey=' +
          productKey
        )
        .subscribe((response) => {
          console.log('activation response:: ', response);
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.devicesList.expiryDate =
              response.data.expiryDate;

            console.log('getDesktopProductKeyDetails response:: ', response);
          }
        });
    } catch (error) {
      console.log(error);
    }
  }
  get translatedDays(): string {
    return this.selectedDays
      .map(day => this.translateService.instant(`PARENTALREPORTS.WEEKDAYS.${day}`))
      .join(', ');
  }
  onChangeSmartParentingToggle(event: any) {
    if (!this.isParentalOn) {
      this.parentalControlForm.get('user')?.disable();
      this.parentalControlForm.get('scheduleType')?.disable();
      this.parentalControlForm.get('accessToInternet')?.disable();
      this.parentalControlForm.get('sundSlot')?.disable();
      this.parentalControlForm.get('monSlot')?.disable();
      this.parentalControlForm.get('tuesSlot')?.disable();
      this.parentalControlForm.get('wedSlot')?.disable();
      this.parentalControlForm.get('thursSlot')?.disable();
      this.parentalControlForm.get('fridSlot')?.disable();
      this.parentalControlForm.get('satSlot')?.disable();
      this.timeSlotForm.get('fromTime')?.disable();
      this.timeSlotForm.get('toTime')?.disable();
      this.featureToggleMap.set("SMART_PARENTAL_SETTINGS", false);
    } else {
      this.parentalControlForm.get('user')?.enable();
      this.parentalControlForm.get('scheduleType')?.enable();
      this.parentalControlForm.get('accessToInternet')?.enable();
      this.parentalControlForm.get('sundSlot')?.enable();
      this.parentalControlForm.get('monSlot')?.enable();
      this.parentalControlForm.get('tuesSlot')?.enable();
      this.parentalControlForm.get('wedSlot')?.enable();
      this.parentalControlForm.get('thursSlot')?.enable();
      this.parentalControlForm.get('fridSlot')?.enable();
      this.parentalControlForm.get('satSlot')?.enable();
      this.timeSlotForm.get('fromTime')?.enable();
      this.timeSlotForm.get('toTime')?.enable();
      this.featureToggleMap.set("SMART_PARENTAL_SETTINGS", true);
    }
    this.isUnsavedPS = true;
    this.restrictWebCategoryArray.controls.forEach(control => {
      const group = control as FormGroup;
      if (!this.isParentalOn) {
        group.get('isChecked')?.disable();
      } else {
        group.get('isChecked')?.enable();
      }
    });
    this.restrictAppCategoryArray.controls.forEach(control => {
      const group = control as FormGroup;
      if (!this.isParentalOn) {
        group.get('isChecked')?.disable();
      } else {
        group.get('isChecked')?.enable();
      }
    });
  }

}
